const API_CONFIG = {
  DEV: {
    apiRootUrl: 'https://portalapi-dev.phishcloud.io/api',
    apiBaseUrl: 'https://portalapi-dev.phishcloud.io/api/portalapi-v2',
  },
  PROD: {
    apiRootUrl: 'https://portalapi-prod.phishcloud.io/api',
    apiBaseUrl: 'https://portalapi-prod.phishcloud.io/api/portalapi-v2',
  },
};

const configuredEnvironment = (process.env.REACT_APP_ENV || '').toUpperCase();
const defaultEnvironment = process.env.NODE_ENV === 'production' ? 'PROD' : 'DEV';
const selectedEnvironment = API_CONFIG[configuredEnvironment] ? configuredEnvironment : defaultEnvironment;
const selectedConfig = API_CONFIG[selectedEnvironment];

export const apiEnvironment = selectedEnvironment;
export const baseApiRootUrl = process.env.REACT_APP_API_ROOT_URL || selectedConfig.apiRootUrl;
const basePCUrl = process.env.REACT_APP_API_BASE_URL || selectedConfig.apiBaseUrl;
export const baseUrlv2 = basePCUrl;
export const emailVerificationUrl =
  process.env.REACT_APP_EMAIL_VERIFICATION_URL || `${baseApiRootUrl}/Auth/EmailIsVerified`;

export default basePCUrl;
